import Helper from './Helper';
import Dropdowntoggler from './Dropdowntoggler';

class Header {
  constructor(config = {}) {
    const {
      mobileNavToggleSelector,
      mainMenuContainerSelector,
      submenuToggleSelector,
      submenuBackToggleSelector,
      searchOpenSelector,
      searchCloseSelector
    } = config;

    this.mobileMenuOpen = false;
    this.body = document.querySelector('body');

    this.mobileNavToggle = document.querySelector(mobileNavToggleSelector);
    this.mainMenuContainer = document.querySelector(mainMenuContainerSelector);
    this.searchOpen = document.querySelector(searchOpenSelector);
    this.searchClose = document.querySelector(searchCloseSelector);
    this.submenuToggles = Array.prototype.slice.call(document.querySelectorAll(submenuToggleSelector));
    this.submenuBackToggles = Array.prototype.slice.call(document.querySelectorAll(submenuBackToggleSelector));

    if(this.mobileNavToggle){
      this.bindEvents();
    }
  }

  bindEvents(){
    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 27 || evt.key == 'Escape' || evt.key == 'Esc') {
        this.closeSubmenus();
      }
    };

    this.searchOpen.addEventListener('click', e => {
      this.closeSubmenus();
      this.openSearch();
    });

    this.searchClose.addEventListener('click', e => {
      this.closeSearch();
    });

    this.mobileNavToggle.addEventListener('click', e => {
      this.toggleMenu();
    });

    this.submenuToggles.forEach((toggler, i) => {
      toggler.addEventListener('click', e => {

        e.preventDefault();
        if(Helper.hasClass(toggler, 'current-toggle') && Helper.hasClass(toggler, 'alpiqmenu__link--level-0')){
          this.closeSubmenus(toggler);
        } else {
          if(!Helper.hasClass(toggler, 'alpiqmenu__link--level-0')){
            let openMenu = document.querySelector('.alpiqmenu__item--level-1.alpiqmenu__item--ancestor-active');
            if(!!openMenu){
              this.closeAnchestorMenu(openMenu);
            }
          } else {
            var dropdownToggler = new Dropdowntoggler({
              dropdownWrapperSelector: '.js-dropdown-wrapper',
              dropdownToggleSelector: '.js-dropdown-toggle',
              dropdownDropSelector: '.js-dropdown',
              needsBackdrop: true,
              externalCall: true
            });
            dropdownToggler.closeAllDropdowns();
          }
          this.openSubmenu(toggler);
        }
      });
    });
    this.submenuBackToggles.forEach((toggler, i) => {
      toggler.addEventListener('click', e => {
        e.preventDefault();
        const currentToggle = toggler.parentElement.parentElement.previousElementSibling;
        this.closeSubmenus(currentToggle);
      });
    });
  }

  openSearch(){
    Helper.addClass(document.querySelector('.header__right'), 'position-fix');
    Helper.addClass(this.body, 'search-open');
    document.querySelector('.header__right').querySelector('input[type="search"]').focus()
  }

  closeSearch(){
    Helper.removeClass(this.body, 'search-open');
    setTimeout(() => {
      Helper.removeClass(document.querySelector('.header__right'), 'position-fix');
    }, 1000);
  }

  toggleMenu(){
    if(this.menuOpen){
      Helper.removeClass(this.mobileNavToggle, 'burger-active');
      Helper.removeClass(this.mainMenuContainer, 'is-open');
      Helper.removeClass(this.body, 'menu-open');
      this.menuOpen = false;
    } else {
      Helper.addClass(this.mobileNavToggle, 'burger-active');
      Helper.addClass(this.mainMenuContainer, 'is-open');
      Helper.addClass(this.body, 'menu-open');
      this.menuOpen = true;
    }
  }

  closeAnchestorMenu(toggler){
    if(Helper.hasClass(toggler, 'alpiqmenu__item--ancestor-active')){
      Helper.removeClass(toggler, 'alpiqmenu__item--ancestor-active');
    }
  }

  closeSubmenus(toggler){
    // console.log('closesubmenu');
    if(Helper.hasClass(this.body, 'submenu-open')){
      Helper.removeClass(this.body, 'submenu-open');
    }
    if(document.querySelector('.menu-backdrop')){
      if(!Helper.hasClass(this.body, 'menu-open')){
        document.querySelector('.menu-backdrop').remove();
      }
    }
    if(toggler){
      Helper.removeClass(toggler.parentElement, 'active');
      Helper.removeClass(toggler.nextElementSibling, 'active');
      Helper.removeClass(toggler, 'current-toggle');
    } else {
      this.submenuToggles.forEach((toggle, i) => {
        Helper.removeClass(toggle.parentElement, 'active');
        Helper.removeClass(toggle.nextElementSibling, 'active');
        Helper.removeClass(toggle, 'current-toggle');
      });
    }
  }

  openSubmenu(toggler){
    // console.log('opensubmenu');
    if(Helper.hasClass(toggler, 'alpiqmenu__link--level-0')){
      this.closeOthersofLevel('alpiqmenu__link--level-0', toggler);
    }
    if(Helper.hasClass(toggler, 'alpiqmenu__link--level-1')){
      this.closeOthersofLevel('alpiqmenu__link--level-1', toggler);
    }
    Helper.addClass(toggler.parentElement, 'active');
    Helper.addClass(toggler.nextElementSibling, 'active');
    Helper.addClass(toggler, 'current-toggle');
    Helper.addClass(this.body, 'submenu-open');

    if(!document.querySelector('.menu-backdrop')){
      let backdrop = document.createElement('div');
      Helper.addClass(backdrop, 'menu-backdrop');
      this.body.appendChild(backdrop);
      backdrop.addEventListener('click', () => {
        this.closeSubmenus();
      });
    }
  }

  closeOthersofLevel(levelClass, toggler){
    this.submenuToggles.forEach((toggle, i) => {
      if(toggle !== toggler && Helper.hasClass(toggle, levelClass)){
        Helper.removeClass(toggle.parentElement, 'active');
        Helper.removeClass(toggle.nextElementSibling, 'active');
        Helper.removeClass(this.body, 'submenu-open');
        Helper.removeClass(toggle, 'current-toggle');
        if(document.querySelector('.menu-backdrop')){
          if(!Helper.hasClass(this.body, 'menu-open')){
            document.querySelector('.menu-backdrop').remove();
          }
        }
      }
    });
  }

}
export default Header;
